module.exports = require('./helpers/bundle-url').getBundleURL('a0IFD') + "empty.0bf17c37.png";